<nwx-account-info
  [agency]="agency$ | async"
  [products]="products$ | async"
  [productStateMap]="productsWithState$ | async"
  [pni]="pni$ | async"
  [accountId]="accountId$ | async"
></nwx-account-info>
